import type { RouteLocationNormalized } from 'vue-router';

const DOCUMENT_TITLE_SUFFIX = 'Cummins Worldwide Member Portal';

function resolveRouteTitle(to: RouteLocationNormalized): string | undefined {
  for (let i = to.matched.length - 1; i >= 0; i--) {
    const title = to.matched[i].meta.title;

    if (typeof title === 'string' && title.length > 0) {
      return title;
    }
  }

  return undefined;
}

export function applyRouteDocumentTitle(to: RouteLocationNormalized): void {
  const pageTitle = resolveRouteTitle(to);

  if (pageTitle === undefined) {
    return;
  }

  document.title = `${pageTitle} | ${DOCUMENT_TITLE_SUFFIX}`;
}
